import { ONE_DAY_MS, ONE_HOUR_MS } from '~/shared/constants/time'

export const LOAD_BEHIND = 4 * ONE_HOUR_MS // 4 hours back
export const LOAD_AHEAD = 2 * ONE_DAY_MS // two days forward
